import React from "react";
import { FooterContainer } from "./style";
import { NormalText } from "@components/styles/dataDisplay";

const Footer = () => {
  return (
    <FooterContainer>
      <NormalText size="sm" noMargin color="gray">
        © copyright - Aurum Software
      </NormalText>
    </FooterContainer>
  );
};

export default Footer;
